const url = {
  auth: {
    login: "auth/login",
  },
  users: "users",
  ahkam: "ahkam",
};

export default url;
